module.exports = "//static.hsappstatic.net/LoginUI/static-1.14890/img/connect.com-full-logo-color.svg"